import SEO from "../components/SEO";

export default function Disclaimer() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="disclaimer-page">
      <SEO
        title="Legal Disclaimer | Indiana Accident Aid"
        description="Indiana Accident Aid is an attorney-matching service, not a law firm. This disclaimer explains our role, attorney advertising, and the limits of the information on this site."
      />
      <h1 className="font-display font-black text-4xl sm:text-5xl text-forest mb-6">Legal Disclaimer</h1>
      <p className="text-sm text-forest/60 mb-10">Last updated: {new Date().getFullYear()}</p>

      <div className="space-y-6 text-forest/80 leading-relaxed text-base">
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Not a Law Firm</h2>
          <p>
            Indiana Accident Aid is a free informational and attorney-matching service. We are
            <strong> not a law firm</strong>, we do not practice law, and we do not provide legal
            advice, opinions, or representation. Nothing on this website should be construed as
            legal advice for your specific situation.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">No Attorney-Client Relationship</h2>
          <p>
            Using this website, submitting a case-review form, or contacting us does <strong>not</strong>
            {" "}create an attorney-client relationship between you and Indiana Accident Aid, or between
            you and any attorney, unless and until you and an attorney sign a written representation
            agreement. Do not send confidential or time-sensitive information expecting it to create
            such a relationship.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Attorney Advertising</h2>
          <p>
            This website may constitute attorney advertising under applicable rules. Any attorneys you
            are connected with are independent and solely responsible for the legal services they
            provide. We do not endorse or guarantee any particular attorney, and we are not responsible
            for the conduct or outcomes of any legal representation.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">No Guarantee of Results</h2>
          <p>
            Every case is different. Past results, general timelines, statutory references, and example
            scenarios described on this site are for general education only and do not predict or
            guarantee the outcome of any specific matter. Deadlines such as Indiana's statutes of
            limitations and tort-claim-notice periods are strict — consult a licensed Indiana attorney
            promptly about your own case.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Accuracy of Information</h2>
          <p>
            We strive for accuracy, but laws change and information here may become outdated or may not
            apply to your circumstances. This content is not a substitute for advice from a qualified
            attorney licensed in Indiana.
          </p>
        </section>
        <section>
          <h2 className="font-display font-bold text-lg text-forest mb-2">Questions</h2>
          <p>
            Questions about this disclaimer? Please reach us through our{" "}
            <a href="/contact" className="text-terracotta font-semibold hover:underline">contact page</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
